import { buryPoint } from './buried-point';

//关于埋点因全局变量由于网络问题没有生成所导致的失效问题，生成了一个埋点队列（数组）
// window.FAILURE_BURIED_POINT_QUEUE = [];
// window.HAS_QUERY_GOOGLE_ANALYTICS = false;

//执行因全局变量未生成导致失效的埋点队列
// export const doFailureBuriedPointQueue = () => {
//   const queue = window.FAILURE_BURIED_POINT_QUEUE;
//   if (queue.length !== 0) {
//     queue.forEach((element) => {
//       window.gtag(...element);
//     });
//   }
//   window.FAILURE_BURIED_POINT_QUEUE = [];
// };
function buriedPoint(type, params) {
  buryPoint[type](params);
}

// function removeItem(sKey, sPath, sDomain) {
//   document.cookie =
//     encodeURIComponent(sKey) +
//     '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
//     (sDomain ? '; domain=' + sDomain : '') +
//     (sPath ? '; path=' + sPath : '');
// }

/**
 * 跟距cookie隐私管理删除Analytics Cookies
 */
// const getCookieManager = () => {
//   const domain = '.' + document.domain.split('.').slice(-2).join('.');
//   let cookieManager = StorageGetObj('hik_connect_pro_cookie-describe');
//   if (cookieManager && !cookieManager.analyCookie) {
//     window.gtag = null;
//     let cookieList = document.cookie && document.cookie.split(';');
//     for (let i in cookieList) {
//       let item = cookieList[i];
//       let key = item && item.split('=')[0].trim();
//       key.includes('_ga') || key.includes('_gid') ? removeItem(key, '/', domain) : '';
//     }
//   } else {
//     // 若BURIED_POINT_IDENTITY不存在 说明init函数从未执行 启用Analytics cookie 执行init函数
//     window['ga-disable-' + window.BURIED_POINT_IDENTITY] = false;
//     // if (!window.HAS_QUERY_GOOGLE_ANALYTICS) {
//     //   initGA().then(() => {
//     //     doFailureBuriedPointQueue();
//     //   });
//     // }
//   }
// };

export { buriedPoint };
